import ClassWatcher from "./classes/ClassWatcher";

let container = document.querySelector('#twitter-container');

export default function initializeTwitterWidget() {
    let body = document.querySelector('body');

    if (!body.classList.contains('page-template-news')) {
        return;
    }

    let waitForTwttr = setInterval(function () {
        if (typeof window.twttr != 'undefined') {
            if (body.classList.contains('body--contrast')) {
                embedTwitterDarkTheme();
            } else {
                embedTwitterLightTheme();
            }

            clearInterval(waitForTwttr);
        }
    }, 20);


    new ClassWatcher(body, 'body--contrast', embedTwitterDarkTheme, embedTwitterLightTheme);
}

function embedTwitterTimeline(theme) {
    if (!window.twttr) {
        return;
    }

    window.twttr.widgets.createTimeline(
        {
            sourceType: 'profile',
            screenName: container.dataset.profile
        },
        container,
        {
            tweetLimit: '5',
            lang: container.dataset.lang,
            theme: theme,
            chrome: 'transparent'
        }
    );
}

function embedTwitterDarkTheme() {
    container.innerHTML = '';
    embedTwitterTimeline('dark');
}

function embedTwitterLightTheme() {
    container.innerHTML = '';
    embedTwitterTimeline('light');
}